import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import apiManager from '../../utils/apiManager';

import { setIBANDetails } from '../../store/account';

export default function AccountDialog() {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user);
  const isUserInvestor = () => user?.user_type?.includes('Investor');

  useEffect(async () => {
    if (!isUserInvestor()) {
      return;
    }
    // console.log('Fetching IBAN details for user:', user.id);

    try {
      const res = await apiManager.get('/api/wallet/get-iban/');
      // console.log('IBAN Details:', res.data);
      if (res.data) {
        dispatch(setIBANDetails(res.data));
      }
    } catch (error) {
      // console.error('Error fetching IBAN details:', error);
    }
  }, []);

  return null;
}
